/* eslint-disable import/prefer-default-export */
export const SET_API = 'SET_API';
